export default __webpack_public_path__ + "static/media/Group 5498.457afc51.svg";